import images from "./images";

const works = [
  {
    codeLink: "https://github.com/ammansoomro/investment-tracker",
    description:
      "A comprehensive full-stack web application for tracking and managing your investment portfolio across multiple asset classes. Built with modern technologies to provide real-time portfolio insights, beautiful visualizations, and intuitive user experience. Features multi-asset tracking including cryptocurrencies (BTC, ETH, SOL, XRP, and more), Pakistan Stock Exchange (PSX) stocks, mutual funds, silver holdings (bars, coins, tola), and VPS (Voluntary Pension Scheme) funds. Includes a real-time portfolio overview with interactive charts, profit/loss tracking, asset breakdown with performance metrics, salary allocation tools, investment calculator, SIP calculator, and automatic crypto price updates via CoinGecko API.",
    imgUrl: images.investmenttracker,
    tags: ["React", "Node"],
    title: "Investment Tracker",
    technologies: [
      "TypeScript",
      "React",
      "Node.js",
      "PostgreSQL",
      "Prisma",
      "Express.js",
      "Vite",
      "Tailwind CSS",
      "Framer Motion",
      "Recharts",
      "Radix UI",
      "React Router DOM",
      "Axios",
      "CoinGecko API",
    ],
    screenshots: [
      images.investmenttracker,
      images.investmenttracker1,
      images.investmenttracker2,
      images.investmenttracker3,
      images.investmenttracker4,
      images.investmenttracker5,
      images.investmenttracker6,
      images.investmenttracker7,
      images.investmenttracker8,
      images.investmenttracker9,
      images.investmenttracker10,
      images.investmenttracker11,
      images.investmenttracker12,
      images.investmenttracker13,
      images.investmenttracker14,
      images.investmenttracker15,
    ],
  },
  {
    codeLink: "https://github.com/ammansoomro/pr-analytics-dashboard",
    description:
      "A comprehensive full-stack web application designed as an in-house tool to help development teams monitor and gain deep insights into their pull request workflows, code quality, and team collaboration patterns. Built with modern web technologies, this dashboard transforms raw GitHub and Bitbucket PR data into actionable intelligence through intuitive visualizations, AI-powered analysis, and detailed reporting capabilities. Features multi-platform integration (GitHub OAuth and Bitbucket), comprehensive PR analysis with defect tracking and categorization, team collaboration insights with reviewer analytics, AI-powered insights using OpenAI GPT-4o-mini for natural language analysis, advanced filtering and search capabilities, detailed PR views with defect management, and interactive visualizations powered by Recharts. This in-house monitoring solution provides real-time visibility into team performance and pull request health, enabling engineering managers and tech leads to make data-driven decisions about code quality, review processes, and team collaboration effectiveness.",
    imgUrl: images.pranalysisdashboard,
    tags: ["React", "Node"],
    title: "PR Analysis Dashboard",
    technologies: [
      "TypeScript",
      "React",
      "Node.js",
      "Express.js",
      "MySQL",
      "Prisma",
      "Vite",
      "Tailwind CSS",
      "Framer Motion",
      "Recharts",
      "Radix UI",
      "React Router DOM",
      "Passport.js",
      "OpenAI API",
      "GitHub API",
      "Bitbucket API",
      "Axios",
    ],
    screenshots: [
      images.pranalysisdashboard,
      images.pranalysisdashboard1,
      images.pranalysisdashboard2,
      images.pranalysisdashboard3,
      images.pranalysisdashboard4,
      images.pranalysisdashboard5,
      images.pranalysisdashboard6,
      images.pranalysisdashboard7,
      images.pranalysisdashboard8,
      images.pranalysisdashboard9,
    ],
  },
  {
    codeLink: "https://github.com/ammansoomro/prompt-o-phobia",
    description:
      "Empower your creativity using Next.js. Shape unique prompts for advanced AI interaction, revolutionizing AI-driven experiences. Your innovation knows no bounds with this platform. Share and redefine possibilities today!",
    imgUrl: images.promptophobia,
    projectLink: "https://prompt-o-phobia.vercel.app/",
    tags: ["Next"],
    title: "Prompt-O-Phobia",
    technologies: ["Next.js", "React", "TypeScript", "Tailwind CSS", "AI Integration"],
    screenshots: [images.promptophobia],
  },
  {
    codeLink: "https://github.com/ammansoomro/arcade-vault",
    description:
      "A small-scale e-commerce platform built with React, Node.js, Stripe, and Multer to explore payment processing and file uploads. Arcade-Vault is an experimental gaming store where users can browse and purchase controllers, consoles, games, and headsets. This project started as an exploration of Stripe Payments but later expanded to include Multer for file uploads, leading to a broader learning experience.",
    imgUrl: images.arcadevault,
    tags: ["React"],
    title: "Arcade Vault",
    technologies: ["React", "Vite", "Tailwind CSS", "Node.js", "Express.js", "MongoDB", "Stripe", "Multer"],
    screenshots: [
      images.arcadevault,
      images.arcadevault1,
      images.arcadevault2,
      images.arcadevault3,
      images.arcadevault4,
      images.arcadevault5,
    ],
  },
  {
    codeLink: "https://github.com/ammansoomro/Moviebase",
    description:
      "This project is a YTS clone built using React and its libraries, and it's populated using YTS official API. It provides users with an interface that allows them to browse, search and download movies torrents from YTS website.",
    imgUrl: images.moviebase,
    projectLink: "https://moviebase-yts.netlify.app/",
    tags: ["React"],
    title: "Moviebase",
    technologies: [
      "React",
      "HTML",
      "CSS",
      "styled-components",
      "react-router-dom",
      "framer-motion",
      "react-paginate",
      "@splidejs/react-splide",
      "YTS API",
    ],
    screenshots: [
      images.moviebase,
      images.moviebase1,
      images.moviebase2,
      images.moviebase3,
    ],
  },
  {
    codeLink: "https://github.com/ammansoomro/SMD_Project",
    description:
      "React Native app featuring user authentication, displaying a variety of PlayStation accessories and games. Users can browse, add items to a mock shopping cart, and simulate a purchase experience.",
    imgUrl: images.gamewareshub,
    tags: ["Native", "React"],
    title: "GameWares Hub",
    technologies: ["React Native", "JavaScript", "Authentication", "State Management"],
    screenshots: [
      images.gamewareshub,
      images.gamewareshub1,
      images.gamewareshub2,
      images.gamewareshub3,
      images.gamewareshub4,
      images.gamewareshub5,
    ],
  },
  {
    codeLink: "https://github.com/ammansoomro/ShadowSensei",
    description:
      "A web-based, Student Management System built using HTML, CSS, PHP, and JavaScript that would store all the data about the students and their courses on a PHP MySQL server.",
    imgUrl: images.shadowsensei,
    tags: ["Php"],
    title: "Shadow Sensei",
    technologies: ["PHP", "MySQL", "HTML5", "CSS3", "JavaScript"],
    screenshots: [
      images.shadowsensei,
      images.shadowsensei1,
      images.shadowsensei2,
      images.shadowsensei3,
      images.shadowsensei5,
    ],
  },
  {
    codeLink: "https://github.com/ammansoomro/LavenderLogs",
    description:
      "A web-based, Blog Post Management System developed using Php, HTML, and JS including MySQL Database as a backend to store all the data. The consists of different dashboards based on user-role.",
    imgUrl: images.lavenderlogs,
    tags: ["Php"],
    title: "Lavender Logs",
    technologies: ["PHP", "MySQL", "HTML5", "CSS3", "JavaScript", "Role-Based Access"],
    screenshots: [
      images.lavenderlogs,
      images.lavenderlogs2,
      images.lavenderlogs3,
      images.lavenderlogs4,
      images.lavenderlogs5,
    ],
  },
  {
    codeLink: "https://github.com/ammansoomro/GradeCalc",
    description:
      "This is a GPA calculator web application, built using HTML, CSS, and JavaScript. The application allows users to calculate their semester and cumulative GPAs based on the grades they received in their courses. It calculates semester GPA based on credit hours and grades for up to 8 courses, and cumulative GPA based on credit hours and grades for up to 8 semesters. Features a simple and easy-to-use interface with automatic GPA calculation.",
    imgUrl: images.gradecalc,
    tags: ["HTML"],
    title: "Grade Calc",
    technologies: ["HTML5", "CSS3", "JavaScript"],
    screenshots: [
      images.gradecalc,
      images.gradecalc1,
    ],
  },
];

export default works;
